module.exports = __webpack_public_path__ + "static/media/demoimg.abe394ab.png";